import {gql} from "@apollo/client";

export const UPDATE_ORDER_ACTUAL_DIMENSION = gql`
    mutation UpdateOrderActualDimension($input: UpdateOrderActualDimensionInput!) {
        updateOrderActualDimension(input: $input)
    }
`;

export interface UpdateOrderActualDimensionInput {
    orderId: number;
    lengthCm?: number | null;
    widthCm?: number | null;
    heightCm?: number | null;
}

export interface UpdateOrderActualDimensionResponse {
    updateOrderActualDimension: boolean;
}

